import { render, staticRenderFns } from "./StatsList.vue?vue&type=template&id=2c3af382&scoped=true&"
import script from "./StatsList.vue?vue&type=script&lang=js&"
export * from "./StatsList.vue?vue&type=script&lang=js&"
import style0 from "./StatsList.vue?vue&type=style&index=0&id=2c3af382&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3af382",
  null
  
)

export default component.exports